module.exports = __webpack_public_path__ + "img/xr_location.fb941ba6.jpg";